import { createRoot } from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@hydrodigital/design-system';
import store from '@/redux/store.ts';
import App from './App';
import { StyleProvider } from '@ant-design/cssinjs';
import '@/assets/css/main.scss';
import { msalInstance } from './utils/msal';
import * as Sentry from '@sentry/react';
import '@hydrodigital-datepicker-css';
import { LocaleProvider } from '@/contexts/LocaleContext';
let sentryDsn = import.meta.env.VITE_SENTRY_DSN;
let environment = import.meta.env.VITE_APP_ENV;

if (sentryDsn) {
  const isProduction = environment === 'prod' || environment === 'production';

  Sentry.init({
    dsn: sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: isProduction ? 0.1 : 1,
    replaysOnErrorSampleRate: isProduction ? 0.5 : 1,
    replaysSessionSampleRate: 0,
    environment: environment ?? 'dev',
    beforeSend(event) {
      if (event.breadcrumbs) {
        event.breadcrumbs = event.breadcrumbs.map(breadcrumb => {
          if (breadcrumb.data?.headers?.Authorization) {
            breadcrumb.data.headers.Authorization = '[REDACTED]';
          }
          return breadcrumb;
        });
      }
      return event;
    },
  });
}

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
  <Provider store={store}>
    <ThemeProvider>
      {/* <Router /> */}
      <StyleProvider hashPriority="high">
        <LocaleProvider>
          <App msalInstance={msalInstance} />
        </LocaleProvider>
      </StyleProvider>
    </ThemeProvider>
  </Provider>,
  // </StrictMode>
);
